var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwipeRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3871 2.74898C11.4401 3.24207 12.4227 3.86796 13.3106 4.61072C13.3868 4.67443 13.4357 4.75978 13.4541 4.85126L13.455 4.85608M11.4406 7.97724C12.2205 7.11484 12.884 6.15725 13.415 5.12859C13.4597 5.0419 13.4721 4.94616 13.455 4.85608M13.455 4.85608L13.4868 4.85126M13.455 4.85608C9.53522 5.45481 5.98981 7.19149 3.1665 9.71841M10.7877 23.5152L7.94496 13.5311C7.77269 12.9261 8.16536 12.3058 8.78595 12.2027C10.6945 11.8855 12.574 12.9081 13.3446 14.6827L14.4814 17.3009L18.4088 4.55914C18.8426 3.15172 20.3352 2.36245 21.7426 2.79626C23.1501 3.23008 23.9393 4.72268 23.5055 6.1301L21.1491 13.7752L26.961 16.6847C31.2222 18.8182 29.8436 23.9626 27.4706 27.0344C23.2911 32.4447 12.6342 30.0005 10.7877 23.5152Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeRight);
export default __webpack_public_path__ + "static/media/SwipeRight.761967c4383160982d3d6ab6855baac4.svg";
export { ForwardRef as ReactComponent };